import { getHomeSelectedWork } from '../../config/work';
import { WorkCarousel } from '../work/WorkCarousel';
import { ButtonLink } from '../ui/ButtonLink';
import { SectionHeading } from '../ui/SectionHeading';

export function SelectedWorkSection() {
  const selected = getHomeSelectedWork();

  return (
    <section className="section selected-work">
      <div className="shell">
        <SectionHeading
          eyebrow="Work"
          title="Selected Website Concepts"
          text="Current concept projects demonstrate design and development directions. They are labelled clearly and are not presented as commissioned client work."
        />
        <WorkCarousel items={selected} ariaLabel="Selected website concepts" />
        <div className="section-action"><ButtonLink href="/work" variant="secondary">View all work</ButtonLink></div>
      </div>
    </section>
  );
}
